import React, { useCallback, useState, useEffect } from 'react';
import { Collapse as ACollapse, CollapseProps as Props } from 'antd';
import Icon from '../Icon';
import { isArray } from 'lodash';

export interface CollapseProps extends Props {
  defaultActiveKey?: string[];
  activeKey?: string[];
}

interface CollapseInterface extends React.FC<CollapseProps> {
  Panel: typeof ACollapse.Panel;
}

const ExpandIcon: React.FC<any> = ({ isActive }) => (
  <Icon primary icon={isActive ? 'arrow-up' : 'arrow-down'} size={8} />
);

const Collapse: CollapseInterface = ({
  expandIcon,
  children,
  onChange,
  defaultActiveKey,
  accordion,
  activeKey: active,
  expandIconPosition = 'right',
  ...props
}) => {
  const [activeKey, setActiveKey] = useState<string[]>(defaultActiveKey || []);

  useEffect(() => {
    setActiveKey(defaultActiveKey || []);
  }, [defaultActiveKey]);

  const onChangeHandler = useCallback(
    (key) => {
      if (onChange) {
        return onChange(key);
      }
      if (isArray(activeKey) && activeKey?.length > 1 && accordion) {
        return setActiveKey([]);
      }
      setActiveKey(key);
    },
    [activeKey]
  );

  return (
    <ACollapse
      {...props}
      accordion={
        accordion && isArray(activeKey) && activeKey?.length > 1
          ? false
          : accordion
      }
      expandIconPosition={expandIconPosition}
      defaultActiveKey={defaultActiveKey}
      expandIcon={expandIcon || ExpandIcon}
      activeKey={active || activeKey}
      onChange={onChangeHandler}
    >
      {children}
    </ACollapse>
  );
};

Collapse.Panel = ACollapse.Panel;

export default Collapse;
